import { z } from 'zod';

export const EmpresaSlugTokenSchema = z.object({
    cliente_idpk: z.number(),
    empresa_idpk: z.number(),
    token: z.string(),
    token_exp: z.string(),
});

export type EmpresaSlugToken = z.infer<typeof EmpresaSlugTokenSchema>;
